const CustomHeadElements = () => null;

export default CustomHeadElements;
